import { JsonDocumentEditor } from "./JsonDocumentEditor";
import { schemaIdOfInstance, usePipelineStaging } from "./pipelineStaging";
import { SchemaEncodingDropdown } from "./SchemaEncodingDropdown";
import { SchemaVariantDropdown } from "./SchemaVariantDropdown";

// Figma Bridge_PipelineCode "New schema" (14398-200859 / 14442-316244) — the
// sink-tab SCHEMA editor: the shared JSON editor panel with old /studio's
// schema placeholder and no sample loaders.
export function SchemaEditor() {
  const {
    schemaDocument,
    setSchemaDocument,
    effectiveSelectedId,
    schemas,
    unstage,
  } = usePipelineStaging();

  // ⌘Z down to the placeholder steps back past the definition fill —
  // taking the staged schema on the editor with it (TTTL-191), like the
  // row's remove button. Slot drafts (untitled) are left alone.
  const stagedId = schemaIdOfInstance(effectiveSelectedId);
  const staged =
    stagedId !== null && schemas.some((s) => s.id === stagedId)
      ? stagedId
      : null;

  // The unreferenced-schema warning lives in the Stages panel (StageNavPanel's
  // alert under the unattached block), not over the editor.
  return (
    <JsonDocumentEditor
      testIdBase="schema"
      documentName="schema"
      value={schemaDocument}
      onChange={setSchemaDocument}
      onUndoToEmpty={staged !== null ? () => unstage(staged) : undefined}
      placeholder='{"type": "record", "name": "...", "fields": [...]}'
      statusExtras={
        <>
          <SchemaEncodingDropdown
            schemaDocument={schemaDocument}
            setSchemaDocument={setSchemaDocument}
          />
          <SchemaVariantDropdown />
        </>
      }
    />
  );
}
